import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const LXP_ROLES = ["lxp_student", "lxp_recruiter", "lxp_university"] as const;

export const getMyLxpRoles = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const { data } = await supabase.from("user_roles").select("role").eq("user_id", userId);
    const roles = (data ?? []).map((r: any) => r.role);
    return {
      isStudent: roles.includes("lxp_student"),
      isRecruiter: roles.includes("lxp_recruiter"),
      isUniversity: roles.includes("lxp_university"),
      isAdmin: roles.includes("admin"),
    };
  });

export const setMyLxpRole = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((i: unknown) => z.object({ role: z.enum(LXP_ROLES) }).parse(i))
  .handler(async ({ data, context }) => {
    const { supabase, userId } = context;
    // Self-assignment is safe for LXP audience roles (student/recruiter/university);
    // admin cannot be self-assigned because 'admin' isn't in the enum here.
    const { error } = await supabase.from("user_roles").upsert(
      { user_id: userId, role: data.role },
      { onConflict: "user_id,role" },
    );
    if (error) throw new Error(error.message);
    return { ok: true };
  });
